export const de_DE_informal = {
  translation: {
    hero: {
      title: "Willkommen bei der Werkstatt-Buchung von {{organization}}",
      subtitle: null,
    },
    welcomeModal: {
      title: "Du verlässt nun die Seite von {{organization}}",
      text: "Bitte beachte, dass Du dich auf einer Website befindest, für deren Inhalt {{organization}} nicht verantwortlich ist und die Datenschutzbestimmungen von {{organization}} keine Anwendung finden.",
    },
    Werkstatt: "Werkstatt",
    Pruefstelle: "Prüfstelle",
    error:
      "Ups, es gab ein Problem beim Laden der Seite. Bitte lade die Seite neu. Versuch es in 5 Minuten erneut, falls das Problem weiterhin besteht.",
    "Waehlen Sie einen Service.": "Wähle einen Service.",
    "Waehlen Sie Ihre Marke.": "Wähle deine Marke.",
    Antriebsart: "Antriebsart",
    Fahrzeugart: "Fahrzeugart",
    PKW: "PKW",
    Nutzfahrzeug: "Nutzfahrzeug",
    Verbrennungsmotor: "Verbrennungs\u00ADmotor",
    "Elektro-/Hybridmotor": "Elektro-/ Hybridmotor",
    "Waehlen Sie Ihren Wunschort.": "Wähle deinen Wunschort.",
    "Werkstatt suchen": "Werkstatt suchen",
    "Rueckgabestation suchen": "Rückgabestation suchen",
    chooseSubServices: "Wähle die benötigten Services",
    chooseTireAmount: "Wähle die Anzahl der Reifen aus.",
    optionalSubservice: "Optional buchbarer Zusatzservice.",
    yes: "Ja",
    no: "Nein",
    benefits: {
      title: "Deine Vorteile",
      "bullet-point-1": "Freie Termine direkt online buchen",
      "bullet-point-2":
        "Die besten Werkstattpartner auf einem Blick – bewertet nach den Qualitätsstandards von {{organization}}",
      "bullet-point-3": "Exklusive Zusatzservices wie Hol- und Bring und Ersatzfahrzeug hinzufügen",
      feedbackText:
        "Du hast Anregungen oder etwas funktioniert nicht wie erwartet? Wir würden es gerne erfahren.",
    },
    contactForm: {
      headline: "Fast geschafft!",
      "sub-headline": "Wie erreichen wir dich?",
      "address-label": "Wo soll das Auto abgeholt und wieder hingebracht werden?",
      "mileage-label": "Kilometerstand",
      "number-plate-label": "Wie lautet dein KFZ-Kennzeichen?*",
      "message-label-required": "Bitte teile der {{garageType}} mit, welches Anliegen du hast:*",
      "message-label": "Möchtest du der {{garageType}} noch etwas mitteilen?",
      "slot-out-of-stock":
        "Dein gewünschter Termin ist leider inzwischen vergriffen. Bitte suche einen neuen Termin aus.",
      submit: "Terminbuchung abschließen",
      "mandatory-field-notice": "*Pflichtangaben",
      marketing:
        "Ich möchte Neuigkeiten, Angebote und Aktionen von repareo via Email erhalten. Widerruf jederzeit möglich.",
      adac: "Ich bin ADAC Mitglied und  möchte an der <span>ADAC 3 % Cashback-Action</span> teilnehmen",
      "adac-tip":
        "Als ADAC Mitglied bekommst du über repareo 3 % Cashback auf deine Werkstatt-Rechnung (Netto). Sobald die Werkstatt eine Rechnung ausgestellt hat, sendest du uns diese einfach per E-Mail. Wir überweisen dir dann dein Geld.",
      "rentalCar-label": "Mietwagenkategorie*",
      vinLabel: "Fahrzeug-Identifizierungsnummer (FIN)",
      vinHint:
        "Die FIN steht in der Zulassungsbescheinigung Teil I (Fahrzeugschein Feld 'E') und Teil II (Fahrzeugbrief). Sie existiert auch 'physisch' und meist mehrfach am Fahrzeug selbst etwa an der B-Säule des Türrahmens, also zwischen Vorder- und Hintertür, in der Fahrertür, im Motor- und Kofferraum, unter der Motorhaube oder auf dem Armaturenbrett.",
      vinInvalidHint:
        "Die Buchstaben I, O, Q sind nicht erlaubt. Wahrscheinliche Verwechslung mit den Zahlen 1 oder 0.",
      claimNumberLabel: "Schadennummer (falls vorhanden)",
      claimNumberLabelRequired: "Schadennummer*",
      claimNumber: {
        label: {
          default: "Schadennummer (falls vorhanden)",
          required: "Schadennummer*",
        },
        placeholder: {
          default: "z.B. 12.345.678/TK25/1",
        },
        hint: {
          default:
            "Sofern dir bereits eine Schadennummer im Format 12.345.678/TK25/1 bekannt ist, gebe diese bitte an.",
          required:
            "Die Schadennummer findest du in der E-Mail über die du unseren Online-Service aufgerufen hast.",
        },
      },
      contractNumber: { label: "Vertragsnummer", placeholder: "123ABC" },
      placeholders: {
        "first-name": "Vorname*",
        "last-name": "Nachname*",
        email: "E-Mail*",
        phone: "Telefonnummer für Rückfragen*",
        street: "Strassenname und Hausnummer",
        postcode: "Postleitzahl",
        city: "Wohnort",
        addition: "Adresszusatz",
        message: "Anmerkungen (optional)",
        "message-required": "Anmerkungen",
      },
      validationErrors: {
        "first-name": "Bitte gebe deinen Vornamen an.",
        "last-name": "Bitte gebe deinen Nachnamen an.",
        email: "Bitte gebe eine gültige E-Mail-Adresse an.",
        phone: "Bitte gebe eine gültige Telefonnummer an.",
        "number-plate": "Bitte gebe das Kfz-Kennzeichen deines Fahrzeuges an.",
        mileage: "Bitte gebe den Kilometerstand deines Fahrzeuges an.",
        message: "Bitte gebe dein Anliegen an.",
        tos: "Bitte akzeptiere unsere Nutzungsbedingungen und Datenschutzerklärung.",
        postcode: "Die Postleitzahl darf nur Ziffern enthalten.",
      },
      numberCheck: {
        title: "Kennzeichen korrekt?",
        text: "Bitte gehe sicher, dass dein Kennzeichen korrekt ist: {{numberplate}}.",
      },
      benefits: {
        "benefit-1": "Kostenfreie Stornierung",
        "benefit-2": "Alle Infos per E-Mail",
      },
      vehicleReturn: {
        submit: "Terminanfrage absenden",
      },
      reviewOptIn: {
        label:
          "Ich willige ein, einmalig per E-Mail zu einer Fahrerbefragung kontaktiert zu werden.",
      },
    },
    contact: {
      title: "Kontakt",
      text: "Hast du Fragen zur Buchung? Lilly steht dir zur Seite.",
      reachability: "8 - 20 Uhr | Montag - Samstag",
      email: {
        label: "E-Mail",
        link: "mailto:werkstattmeister@repareo.de",
        title: "werkstattmeister@repareo.de",
      },
      phone: {
        label: "Telefon",
        link: "tel:004989244182010",
        title: "+49 89 244 182 010",
      },
    },
    keyNumber: {
      headline: "Gib hier deine Fahrzeugschein-Daten ein.",
      submit: "Bestätigen",
      "to-brand": "oder gehe zurück zur",
      "brand-selection": "Markenauswahl",
    },
    keyNumberApproval: {
      headline: "Ist das dein Fahrzeug?",
      error:
        "Wir konnten leider kein passendes Fahrzeug finden. Bitte nutze die Marken- und Modellauswahl.",
      "no-vehicle-found": "Kein Fahrzeug gefunden",
      "no-vehicle-found-tip": "Bitte korrigiere deine Angaben oder nutze die Markenauswahl.",
    },
    location: {
      headline: "Wo suchst du eine Werkstatt?",
      subheadline:
        "Stundensätze variieren stark nach Region, daher fragen wir die Postleitzahl ab.",
      submit: "Weiter",
    },
    brand: {
      headline: "Welche Marke fährst du?",
      "skip-steps": "oder überspringe die ersten 3 Schritte mit den Daten aus deinem ",
      "vehicle-registration": "Fahrzeugschein",
    },
    brandList: {
      "search-brand": "Suche hier nach deiner Marke",
      "important-brands": "Häufige Marken",
      "show-all-brands": "Alle Marken anzeigen",
    },
    generation: {
      "choose-model": "Wähle dein {{brand}} Modell",
      "skip-steps": "oder überspringe die ersten 3 Schritte mit den Daten aus deinem ",
      "vehicle-registration": "Fahrzeugschein",
    },
    generationList: {
      "search-generation": "Suche hier nach deinem Modell",
    },
    bodies: {
      headline: "Bauform wählen",
      subheadline:
        "Du weißt nicht genau, was du hier anklicken sollst? Dann lasse die Felder einfach frei. Wir\n" +
        "                        kalkulieren dann mit dem Basismodell. Die Werkstatt wird dir auf Basis deines Fahrzeuges einen\n" +
        "                        Kostenvoranschlag erstellen.",
      submit: "Weiter",
    },
    gearbox: {
      headline: "Wähle dein Getriebe:",
      subheadline: "Je nach Getriebe können Inspektionsintervalle unterschiedlich ausfallen.",
    },
    equipment: {
      headline: "Wähle deine Ausstattungsmerkmale:",
      subheadline:
        "Du weißt nicht genau, was du hier anklicken sollst? Dann lasse die Felder einfach frei. Wir\n" +
        "                        kalkulieren dann mit dem Basismodell. Die Werkstatt wird dir auf Basis deines Fahrzeuges einen\n" +
        "                        Kostenvoranschlag erstellen.",
      submit: "Weiter",
    },
    motorization: {
      headline: "Welchen Motor hat dein {{brand}} - {{generation}}:",
      "skip-steps": "oder überspringe die ersten 3 Schritte mit den Daten aus deinem ",
      "vehicle-registration": "Fahrzeugschein",
    },
    motorizationList: {
      "fuel-type": "Kraftstoff:",
    },
    registrationDate: {
      headline: "Erstzulassung",
      submit: "Weiter",
      description:
        "Auch die Erstzulassung wird bei vielen Modellen im Serviceintervall mit einbezogen.",
    },
    mileage: {
      headline: "Kilometerstand wählen",
      subheadline: "Je nach Kilometerstand ist ein anderer Service fällig.",
      submit: "Weiter",
    },
    submit: {
      headline: "Erhalte jetzt deinen gratis Kostenvoranschlag:",
      email: "E-Mail Adresse",
      phone: "Rufnummer (optional)",
      button: "<b>Einschätzung erhalten</b> <br/>Kostenlos und unverbindlich",
      "benefit-1": "Detaillierte Kalkulation auf Herstellervorgaben (Teile, was wird gemacht etc.)",
      "benefit-2":
        "Zugang zu richtig guten Werkstätten mit Preiseinschätzungen zu deinem angefragten Service",
      "benefit-3": "Online Terminvereinbarung",
    },
    profileHeader: {
      "checked-by": "geprüft durch {{organization}}",
      rating: "Weiterempfehlung",
      "no-reviews": "Noch keine Bewertung",
      "nationwide-service-1": "Mobiler Service (deutschlandweit)",
      "nationwide-service-2": "Diese Werkstatt kommt zu dir nach Hause",
    },
    summary: {
      text: "Vielen Dank, deine Terminbuchung ist erfolgreich bei uns eingegangen. Du erhältst die finale Bestätigung separat per E-Mail.",
      "contact-us-repareo":
        "Solltest du Fragen zu deiner Terminbuchung haben, kannst du uns per Telefon oder E-Mail erreichen.",
      "contact-us-partner":
        "Solltest du Fragen zu deiner Terminbuchung haben, kannst du repareo per Telefon oder E-Mail erreichen.",

      vehicleReturn: {
        text: "Vielen Dank, deine Terminanfrage ist erfolgreich bei uns eingegangen. Du erhältst die finale Bestätigung separat per E-Mail.",
        "contact-us-partner":
          "Solltest du Fragen zu deinem Termin haben, kannst du repareo per Telefon oder E-Mail erreichen.",
      },
    },
    booking: {
      headline: "Termin buchen",
      subheadline: "Service(s): {{service}}",
      "slot-taken-1": "Schade! Da war leider jemand schneller und hat deinen Wunschtermin am",
      "slot-taken-2": "reserviert. Bitte wähle einen anderen Termin.",
      "no-slots": "Leider sind für diese Werkstatt aktuell keine freien Termine verfügbar.",
      "no-slots-contact-phone": `Bitte kontaktiere die Werkstatt direkt unter <tel>{{tel}}</tel>.`,
      "error-nearest-slot-gone":
        "Puh, die Werkstatt hat einiges zu tun: Der {{ day }} ist jetzt schon ausgebucht. Ab dem {{ newDay }} sind wieder Termine frei.",
      "next-free-slot": "Nächster freier Termin:",
      "chosen-slot": "Ausgewählter Termin:",
      "please-choose-services": "Bitte wähle die gewünschten Services",
      "more-information-link": "Mehr zum Terminablauf",
      hint: "Finale Terminbestätigung erfolgt durch die Prüfstelle.",
      blocking: "Termin wird reserviert...",
      submit: "Termin sichern",
      requestCallback: "Rückruf anfordern",
      moreInformation: {
        headline: "Wie genau läuft der Termin ab?",
        "bullet-point-1": "Deine Buchung geht direkt in den Kalender der {{garageType}}.",
        "bullet-point-2": "Bitte gib dein Auto zu Beginn des Termins ab.",
        "bullet-point-3":
          "Die Werkstatt informiert dich telefonisch, sobald du dein Auto abholen kannst.",
        "bullet-point-4": "Du kannst deinen Termin jederzeit kostenfrei absagen.",
        "bullet-point-5": "",
        "bullet-point-6": "",
        "instant-booking":
          "Diese Werkstatt erhält deinen gebuchten Termin direkt in den Kalender. Somit ist der Termin sofort bestätigt.",
        "request-booking":
          "Diese Werkstatt erhält eine Terminanfrage und bestätigt deinen Wunschtermin so schnell wie möglich.",
      },
      calendarDisclaimer: "",
      vehicleReturn: {
        headline: "Termine",
        submit: "Termin auswählen",
      },
    },

    checkout: {
      orderSummary: {
        headline: "Terminübersicht",
      },
    },

    profileDetails: {
      headline: "Weitere Infos zur {{garageType}}",
      "opening-hours": "Öffnungszeiten",
      description: "Beschreibung",
      "default-description":
        " Willkommen auf der repareo-Profilseite von {{garage}}. Diese {{garageType}} hat\n" +
        "                            leider selbst noch keine weiteren Informationen auf repareo hinterlegt. Du kannst dennoch\n" +
        '                            jederzeit über "Termin sichern" rechts oben einen Termin bei dieser {{garageType}} über repareo\n' +
        "                            buchen.",
      "description-disclaimer":
        "Die folgende Beschreibung richtet sich an Privatkunden der {{garageType}}. Als Nutzer eines {{organization}} Fahrzeugs sind ggf. nicht alle genannten Services erhältlich.",
      days: {
        monday: "Montag",
        tuesday: "Dienstag",
        wednesday: "Mittwoch",
        thursday: "Donnerstag",
        friday: "Freitag",
        saturday: "Samstag",
        sunday: "Sonntag",
      },
    },

    reviews: {
      rating: {
        overall: "Gesamtbewertung",
        rating: "Weiterempfehlung",
        reference: "Basierend auf repareo und Google Nutzern",
        cleanliness: "Sauberkeit und Erscheinungsbild",
        quality: "Qualität der erbrachten Leistung",
        punctuality: "Termintreue",
        competence: "Transparenz und Beratung",
        kindness: "Freundlichkeit der Mitarbeiter",
      },
      "customer-ratings": "Bewertungen von repareo-Kunden",
      "show-less": "Weniger anzeigen",
      "show-more": "Mehr Bewertungen anzeigen",
      "more-reviews": "Weitere Bewertungen",
    },
    brakeScope: {
      headline: "Welchen Umfang soll der Bremsenwechsel haben?",
      "choose-multiple": "Mehrfachauswahl möglich",
      "front-axle": "Vorderachse",
      "rear-axle": "Hinterachse",
      submit: "Weiter",
    },
    vehicleDelivery: {
      "identity-headline": "Haustürlieferung terminieren",
      "identity-text":
        "Bitte identifiziere dich zunächst über die Leasingvertragsnummer, um deine Wunschtermine und den Lieferort festzulegen.",
      "identity-name": "Nachname",
      "identity-agreement-number": "Leasingvertragsnummer",
      "identity-button": "Zur Lieferung",
      "identity-error-contract":
        "Die Vertragsnummer ist nicht korrekt. Bitte prüfe diese und versuche es erneut.",
      "identity-error-lastName":
        "Der Nachname entspricht nicht dem für diese Vertragsnummer hinterlegtem Namen. Bitte prüfe diesen und versuche es erneut.",
      "identity-error-not-yet-possible":
        "Das Fahrzeug ist nicht zur Lieferung bereit. Bitte kontaktiere auslieferung@mobility-concept.de.",
      "identity-error-wish-already-set":
        "Es wurde bereits eine Lieferung beantragt. Bitte kontaktiere auslieferung@mobility-concept.de für gewünschte Änderungen.",
      "details-headline": "Lieferung",
      "details-address-headline": "Lieferdetails",
      "details-date-headline": "Liefertermin",
      "details-modal-headline": "Lieferdetails ändern",
      "details-modal-text":
        "Hier können Sie einen neuen Empfänger und eine neue Adresse angeben zu der das Fahrzeug geliefert werden soll.<br/><br/>Falls Sie das Fahrzeug nicht selbst entgegennehmen können, haben Sie die Möglichkeit, eine bevollmächtigte Person anzugeben.",
      "details-modal-name": "Name",
      "details-modal-street": "Straße & Hausnummer",
      "details-modal-postcode": "Postleitzahl",
      "details-modal-city": "Ort",
      "details-modal-hint":
        "Hinweis: Bitte beachten Sie, dass Änderungen an der Lieferadresse und dem Wunschtermin nach deren Eingabe nur gegen eine Gebühr vorgenommen werden können.",
      "details-modal-cancel": "Abbrechen",
      "details-modal-accept": "Übernehmen",
      "details-date-text":
        "Bitte gebe 3 mögliche Tage an, an denen das Fahrzeug an der oben genannten Adresse entgegen genommen werden kann.",
      "details-date-1": "Terminwunsch 1",
      "details-date-2": "Terminwunsch 2",
      "details-date-3": "Terminwunsch 3",
      "details-hint": "Ich finde keinen passenden Termin",
      "details-hint-accepted": "Es wurden weitere Termine in den Kalender freigegeben",
      "details-button": "Zur Zusammenfassung",
      "submit-headline": "Zusammenfassung",
      "submit-identity-headline": "Leasingvertragsnummer:",
      "submit-address-headline": "Lieferadresse:",
      "submit-date-headline": "Mögliche Liefertermine:",
      "submit-text":
        "Nach dem Klick auf “Haustürlieferung beantragen”, erhalten Sie in den nächsten Tagen eine Bestätigung Ihres Liefertermins.<br/><br/>Hiermit bestätige ich verbindlich den o.g.  Wunschort für die Zustellung. Eine Änderung zu einem späteren Zeitpunkt ist nicht mehr möglich.<br/><br/>Es können Kosten gem. der AGB entstehen",
      "submit-button": "Haustürlieferung beantragen",
      "summary-headline": "Danke, Haustürlieferung beantragt!",
      "summary-text-1":
        "Du wirst in den nächsten Tagen eine Bestätigung deines Liefertermins erhalten.",
      "summary-text-2": `Bei Fragen wende dich bitte per E-Mail an: <a href="mailto:auslieferung@mobility-concept.de">auslieferung@mobility-concept.de</a>`,
      "submit-error": "Es ist ein Fehler aufgetreten. Bitte versuche es erneut.",
    },
    hint: {
      text: "Alle gezeigten Werkstätten sind offizielle {{organization}} Service-Partner.",
      "repareo-inspection-text":
        "Alle gezeigten Werkstätten führen die Inspektion nach Herstellervorgaben durch und erhalten deine Gewährleistung.",
    },
    // garage list
    "In wenigen Schritten zur Werkstattuebersicht": "In wenigen Schritten zur Werkstattübersicht",
    "Werkstaetten in Ihrer Naehe": "{{service}}: Werkstätten in deiner Nähe",
    "Pruefstellen in Ihrer Naehe": "{{service}}: Prüfstellen in deiner Nähe",
    "Partnerwerkstaetten in Ihrer Naehe": "{{organization}} Partnerwerkstätten in deiner Nähe",
    "Partnerpruefstellen in Ihrer Naehe": "{{organization}} Partnerprüfstellen in deiner Nähe",
    "sort by": "Sortieren nach",
    Listenansicht: "Listenansicht",
    Kartenansicht: "Kartenansicht",
    Umgebung: "Umgebung",
    Verfuegbarkeit: "Verfügbarkeit",
    Zusatzservices: "Zusatzservices",
    "Suche speichern": "Suche speichern",
    "proximity-search-text": "Gebe hier deinen Standort ein, z.B. deine Postleitzahl oder Stadt.",
    Datum: "Datum",
    "Werkstattname suchen": "Werkstattname suchen",
    Marke: "Marke",
    additionalgarages: "Weitere Werkstätten",
    garageList: {
      "no-availability": "Details erfahren",
      sorting: {
        earliest_slot: "Frühester Termin",
        smallest_distance: "Geringste Entfernung",
        shortest_travel_time: "Kürzeste Fahrzeit",
        cheapest_price: "Günstigster Preis",
        best_reviewed: "Beste Bewertung",
        recommended: "Empfehlung",
        partner_recommended: "Standard",
      },
      emptyState: {
        headline: "Wir haben leider keine Werkstatt in deiner Nähe gefunden.",
        description:
          "Wir sind bemüht, unser Netzwerk an Werkstätten und Prüfstellen, die direkt über repareo gebucht werden können, " +
          "ständig zu erweitern. Aktuell haben wir in deiner Nähe leider noch keine buchbare Werkstatt für deinen " +
          "Service. Bei Fragen steht dir unsere Buchungshotline jederzeit zur Verfügung.",
        "bullet-point-1": "",
        "bullet-point-2": "",
      },
      filters: {
        premiumServices: {
          "additional-cost-info": "*ggf. können zusätzliche Kosten anfallen.",
          "additional-cost-infoTireStorageList":
            "*Einlagerung auf eigene Kosten. Abschließende Kosten werden vor Ort in Rechnung gestellt.",
          "additional-cost-infoTireStorageDetail":
            "*Einlagerung auf eigene Kosten. Die Einlagerung ist nicht Bestandteil Ihres Vertrages. Abschließende Kosten werden vor Ort in Rechnung gestellt.",
          "additional-cost-mightNotBeInContract":
            "*Falls nicht im Vertrag enthalten, können zusätzliche Kosten anfallen.",
        },
      },
      badges: {
        "best-reviewed-hint": "Beste Bewertungen basieren auf Daten von repareo und Google Nutzern",
      },
      promotion: {
        discountPrefix: {
          max: "max",
          min: "min",
          from: "ab",
          monthly_from: "mtl. ab",
        },
      },
      gotoAppointmentselect: "Zur Terminauswahl",
      showPhoneNumber: "Telefonnummer anzeigen",
      serviceLocation: "Service-Standort",
      mobileService: "mobiler Service (deutschlandweit)",
      nextAppointment: "Nächster Termin:",
    },
    hotline: {
      headline: "Deine Buchungshotline",
      "phone-link": "tel:004989244182010",
      phone: "+49 89 244182010",
      availability: "Montag - Freitag 8 - 18 Uhr",
      "via-email": "Erfrage Termine alternativ auch gern per Mail an:",
      "via-email-email": "werkstattmeister@repareo.de",
    },
    login: {
      title: "Anmeldung",
      subtitle: "Melden dich mit deinem repareo Account an, um eine Buchung durchzuführen.",
      eMail: "E-Mail",
      password: "Passwort",
      signIn: "Jetzt anmelden",
      validations: {
        email: {
          required: "Bitte gebe Deine E-Mail Addresse an.",
          invalid: "Bitte gebe eine gültige E-Mail Addresse an.",
        },
        password: {
          required: "Bitte gebe Dein Passwort an.",
          minLength: "Das Passwort muss mindestens 8 Zeichen lang sein.",
        },
      },
    },
    vehicleSelector: {
      title: "Für welches Fahrzeug soll gebucht werden?",
      numberPlate: "Kennzeichen",
      searchNumberPlate: "Kennzeichen suchen",
      backToNumberPlateSelection: "Zurück zur Suche",
      isRightVehicle: "Ist dies das richtige Fahrzeug?",
      contractNumber: "Vertragsnummer",
      submit: "Fahrzeug auswählen",
    },
    vehicleReturn: {
      addressModal: {
        headline: "Abholdetails ändern",
        description:
          "Hier können Sie eine neue Kontaktperson und eine neue Adresse angeben von der das Fahrzeug abgeholt werden soll. <br/><br/>Falls Sie das Fahrzeug nicht selbst übergeben können, haben Sie die Möglichkeit, eine bevollmächtigte Person anzugeben.",
        name: {
          label: "Name",
        },
        phone: {
          label: "Telefon",
        },
        email: {
          label: "E-Mail",
          invalid: "Bitte gib eine gültige E-Mail-Adresse ein.",
        },
        street: {
          label: "Straße & Hausnummer",
        },
        postcode: {
          label: "Postleitzahl",
        },
        city: {
          label: "Ort",
        },
        hint: "Hinweis: Bitte beachten Sie, dass Änderungen an der Abholadresse und dem Wunschtermin nach deren Eingabe nur gegen eine Gebühr vorgenommen werden können.",
        cancelButton: {
          label: "Abbrechen",
        },
        acceptButton: {
          label: "Übernehmen",
        },
      },
      "identity-headline": "Kundenlogin",
      "identity-text":
        "Bitte identifizieren Sie sich zunächst über die Leasingvertragsnummer, um die Abholung Ihres Fahrzeuges zu beantragen",
      "identity-name": "Nachname",
      "identity-agreement-number": "Leasingvertragsnummer",
      "identity-button": "Zur Abholung",
      "summary-headline": "Danke, Abholung beantragt!",
      "summary-text-1":
        "Sie werden in den nächsten Tagen eine Bestätigung Ihres Abholtermins erhalten.",
      "summary-text-2": `Bei Fragen wenden Sie sich bitte per E-Mail an: <a href="mailto:abholung@santander.de">abholung@santander.de</a>`,
      "details-headline": "Abholung",
      "details-address-headline": "Abholadresse",
      "details-date-headline": "Abholdatum",
      "details-email-invalid": "Bitte gib eine gültige E-Mail Adresse ein.",
      "details-modal-headline": "Abholdaten ändern",
      "details-date-text":
        "Bitte geben Sie 3 mögliche Tage an, an denen das Fahrzeug an der oben genannten Adresse abgeholt werden kann.",
      "details-date-1": "Option 1",
      "details-date-2": "Option 2",
      "details-date-3": "Option 3",
      "details-button": "Zur Zusammenfassung",
      "submit-headline": "Zusammenfassung",
      "submit-identity-headline": "Leasingvertragsnummer:",
      "submit-address-headline": "Abholadresse:",
      "submit-email-headline": "E-Mail-Adresse:",
      "submit-date-headline": "Mögliche Abholtermine:",
      "submit-text":
        'Nach dem Klick auf "Abholung beantragen", erhalten Sie in den nächsten Tagen eine Bestätigung Ihres Abholtermins.<br/><br/>Hiermit bestätige ich verbindlich den o.g.  Wunschort für die Abholung. Eine Änderung zu einem späteren Zeitpunkt ist nicht mehr möglich.',
      "submit-button": "Kostenpflichtige Abholung beantragen",
      "details-cost-accept":
        "Hiermit bestätige ich, dass die Fahrzeugabholung kostenpflichtig ist und akzeptiere die damit verbundenen Kosten gemäß der ausgewiesenen Preisangabe.",
      errors: {
        noData:
          "Vertragsdaten oder Wunsch-Rückgabedaten fehlen. Bitte starten Sie den Prozess von vorne.",
      },
    },
    contractDetails: {
      error: {
        general: `Etwas ist schiefgegangen. Bitte schreiben Sie eine E-Mail an <a>werkstattmeister@repareo.de</a>`,
        not_found:
          "Wir konnten anhand der Vertragsdaten keinen Vertrag finden. Bitte überprüfe deine Vertragsdaten.",
        does_not_match:
          "Die eingegebenen Daten passen nicht zum gefundenen Vertrag. Bitte überprüfe Vertragsnummer und Kennzeichen.",
      },
    },
  },
};
